export const PRINT_OPTIONS_FORM_NAME = 'printOptions';

export const initialExportForm = {
  recordedDocumentsOptions: {
    showReferences: true,
    exportEmptyData: false,
  },
  liensOptions: {
    exportType: 'summary',
    exportEmptyData: false,
  },
  parkingViolationJudgmentsOptions: {
    loadDate: null, //PVB
    exportEmptyData: false,
  },
  environmentalControlBoardJudgmentsOptions: {
    loadDate: null, //ECB
    exportEmptyData: false,
  },
  transitAdjudicationBureauJudgmentsOptions: {
    loadDate: null, //TAB
    exportEmptyData: false,
  },
  federalTaxLiensOptions: {
    exportEmptyData: false,
    showReferences: false,
  },
  assessmentsOptions: {
    exportEmptyData: false,
  },
  uniformCommercialCodesOptions: {
    exportEmptyData: false,
    showReferences: false,
  },
  emergencyRepairsOptions: {
    exportEmptyData: false,
  },
};
